/**
 * Timing constants — every value encodes a UX bug that was found and fixed in
 * the production widget. Values live in tokens/defaults.json (shared across
 * all implementations via codegen); change them there, never here.
 */
import { TIMING } from "./generated/tokens.js";
/** Chat-widget RPCs land before the agent's text streams in; buffer them this
 * long waiting for the text so the widget sorts below it. */
export const CHAT_WIDGET_GRACE_MS = TIMING.chatWidgetGraceMs;
/** Once the agent text lands, release buffered widgets after this beat so the
 * message paints first. */
export const CHAT_WIDGET_AFTER_TEXT_MS = TIMING.chatWidgetAfterTextMs;
/** Keep the typing dots visible at least this long — instant replies
 * otherwise make the indicator flash. */
export const MIN_TYPING_INDICATOR_MS = TIMING.minTypingIndicatorMs;
